<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/nS71tH/tc-custom/9781488068713.jpg?1728413056729" alt="This image is the cover for the book One Scandalous Christmas Eve"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">One Scandalous Christmas Eve
      </h1>
      <p class="bookDescription body article font2">
        <b>An injured billionaire polo-playing playboy yearns to bed his physiotherapist this Christmas in this passionate romance by a <i>USA Today</i>–bestselling author.</b><br/><br/>Smoldering Dante Acosta has got to be physiotherapist Jess’s sexiest client yet. Even injured, the playboy polo champion exudes a raw power that makes Jess giddy . . . until she discovers he’s bought her parents’ farm out from under her!<br/><br/>Jess’s indignation only adds fuel to the fire raging between them, as they try—and fail—to resist each other. Dante is prepared to fight for their chemistry this Christmas—is he prepared to fight for Jess’s heart?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Stephens
      </h2>
      
      <p class="authorDescription body article">Susan Stephens is passionate about writing books set in fabulous locations where an outstanding man comes to grips with a cool, feisty woman. Susan’s hobbies include travel, reading, theatre, long walks, playing the piano, and she loves hearing from readers at her website. www.susanstephens.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7322909b